import consola from 'consola'

consola.level = process.env.CONSOLA_LEVEL || 0

export default () => {
  consola.withTag('frontend').info('consola level: ', consola.level)
}
